import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { SiteUserModel } from '../../../models/index';
import { SiteService, UserManagementService, CommonService } from 'src/app/services/index';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AddEditUserModalComponent } from '../add-edit-user-modal/add-edit-user-modal.component';
import { AlertService, Constants, ConfirmationDialog } from 'src/app/shared';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {
  formFilter: FormGroup;
  sourceFilterKeyup = new EventEmitter<string>();
  sites: any;
  users: any;
  typeFilterTerm: string;
  siteFilterTerm: string;
  displayedColumns = ['no', 'username', 'email', 'role', 'Site', 'action'];
  dataSource: MatTableDataSource<SiteUserModel>;
  itemCount = 0;
  selectedItemCount = 0;
  types = [
    { value: 'username', viewValue: 'User Name' },
    { value: 'email', viewValue: 'Email' },
    { value: 'role', viewValue: 'Role name' },
    { value: 'multiple', viewValue: 'Multiple Site roles' },
    { value: 'single', viewValue: 'Single Site roles' },
    { value: 'customer', viewValue: 'Customer roles' },
    { value: 'tech', viewValue: 'Tech team roles' }
  ];
  techRoles = ['[IEPSiteUser]', '[IEPTestRole]', '[SitePowerUser]'];
  siteWithUsers: any;

  selection: SelectionModel<SiteUserModel>;
  singleRowSelected = false;
  anyRowSelected = false;
  searchText = '';
  NEW_USER = false;
  EDIT_USER = false;
  DELETE_USER = false;
  constructor(private fb: FormBuilder, private router: Router, private siteService: SiteService,
    private userManagementService: UserManagementService, private dialog: MatDialog,
    private alertService: AlertService, private authService: AuthService,
    private commonService: CommonService) {

    this.NEW_USER = authService.doAuthorization([Constants.ACTIVITY.NEW_USER]);
    this.EDIT_USER = authService.doAuthorization([Constants.ACTIVITY.EDIT_USER]);
    this.DELETE_USER = authService.doAuthorization([Constants.ACTIVITY.DELETE_USER]);
  }

  ngOnInit() {

    this.formFilter = this.fb.group({
      filterByCtr: [],
      siteCtr: [],

    });

    this.selection = new SelectionModel<SiteUserModel>(true, []);

    this.sourceFilterKeyup
      .pipe()
      .subscribe(filter => this.search(filter));

    this.siteService.getAllSites().subscribe(data => {
      this.sites = data;
    });
  }
  processFilter() {
    let userlist = [];

    switch (this.typeFilterTerm) {
      case 'username':
        userlist = this.users.filter(c => c.username.toLowerCase().includes(this.searchText));
        break;
      case 'email':
        userlist = this.users.filter(c => c.email.toLowerCase().includes(this.searchText));
        break;
      case 'role':
        userlist = this.users.filter(c => c.role.toLowerCase().includes(this.searchText));
        break;
      case 'multiple':
        userlist = this.users.filter(c => c.role.includes('IEPSiteUser'));
        break;
      case 'single':
        userlist = this.users.filter(c => c.role.includes('IEPTestRole'));
        break;
      case 'customer':
        userlist = this.users.filter(c => c.role.includes('SitePowerUser'));
        break;
      case 'tech': // 'tech'
        userlist = this.users.filter(c => !this.techRoles.includes(c.role));
        break;
      default:
        userlist = this.users;
        break;
    }
    this.bindData(userlist);
  }
  processFilterBySite() {
    if (!this.commonService.isNullOrUndefined(this.siteFilterTerm) && this.siteFilterTerm !== '') {
      const siteId = this.siteFilterTerm;
      this.userManagementService.getUserListBySite(siteId).subscribe(data => {
        if (data && data.length > 0) {
          this.users = data;
          this.dataSource = new MatTableDataSource<SiteUserModel>(this.users);
          this.dataSource.data = this.users;
          const t = this.users[0].sites.filter(c => { return c.siteId }).join(', ');
        }
      });

    }

  }
  arrayToString(arr) {
    let str = '';
    if (!this.commonService.isNullOrUndefined(arr)) {
      arr.forEach(function (item, index) {
        str += item.siteId;
        if (index != (arr.length - 1)) {
          str += ', ';
        };
      });
    }

    return str;
  }
  search(text) {
    let userlist = [];
    this.searchText = text.toLowerCase();
    switch (this.typeFilterTerm) {
      case 'username':
        userlist = this.users.filter(c => c.username.toLowerCase().includes(this.searchText));
        break;
      case 'email':
        userlist = this.users.filter(c => c.email.toLowerCase().includes(this.searchText));
        break;
      case 'role':
        userlist = this.users.filter(c => c.role.toLowerCase().includes(this.searchText));
        break;
      case 'multiple':
        userlist = this.users.filter(c => c.role.includes('IEPSiteUser'));
        break;
      case 'single':
        userlist = this.users.filter(c => c.role.includes('IEPTestRole'));
        break;
      case 'customer':
        userlist = this.users.filter(c => c.role.includes('SitePowerUser'));
        break;
      default: // 'tech'
        break;
    }
    this.bindData(userlist);
  }
  bindData(data) {
    this.dataSource = new MatTableDataSource<SiteUserModel>(data);
    this.dataSource.data = data;
  }
  addUser() {
    this.openAddEditUserModal(null);
  }
  editUser(user) {
    this.openAddEditUserModal(user);
  }
  removeUser(user) {
    event.preventDefault();
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      width: '50%'
    });
    dialogRef.componentInstance.confirmMessage = Constants.MESSAGE.Delete_Confirm;
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.userManagementService.deleteUser(user.username).subscribe(data => {
          if (data.code === 200) {
            this.processFilterBySite();
            this.alertService.showSuccess(Constants.MESSAGE.Delete_success);
          } else {
            this.alertService.message = Constants.MESSAGE.Delete_failure;
            this.alertService.showError();
          }
        });
      }
    });

  }
  openAddEditUserModal(user) {
    const t = this;
    const dialogRef = this.dialog.open(AddEditUserModalComponent, {
      width: '1100px'
    });
    dialogRef.componentInstance.data = user;
    dialogRef.afterClosed().subscribe(result => {
      if (result.status === true) {
        this.processFilterBySite();
      }
    });
  }
}
